<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>QUEST</h2>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div id="overview" class="subCon">
        <h3 class="con_tit" id="edition">Toad Edition</h3>

        <div class="img">
          <h4>#1 Toad Edition</h4>
          <v-img
            src="@/assets/img/quest/toad/edition.jpg"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
        </div>

        <div class="H60"></div>

        <h3 class="con_tit" id="feature">Toad Feature</h3>

        <div class="img">
          <h4>#1 Toad Edition Feature</h4>
          <v-img
            src="@/assets/img/quest/toad/feature.jpg"
            alt=""
            style="
              width: 60%;
              height: 60%;
              border-radius: 8px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                0 6px 20px 0 rgba(0, 0, 0, 0.19);
              margin: 0 auto;
              align-items: center;
            "
          />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
